import React from 'react';
import FormGroup from './FormGroup';

export interface FormDataListProps {
  name?: string;
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  register?: any;
  required?: boolean;
  error?: unknown;
  errorMessage?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  helpContent?: React.ReactNode;
  items?: string[];
}

const FormDataList = ({
  name,
  label,
  placeholder,
  defaultValue,
  register,
  required,
  error,
  errorMessage,
  onChange,
  className,
  autoFocus,
  disabled,
  helpContent,
  items,
}: FormDataListProps) => (
  <FormGroup
    label={label}
    error={Boolean(error)}
    errorMessage={errorMessage}
    required={required}
    helpContent={helpContent}
  >
    <input
      {...(name != null ? register(name, { required }) : {})}
      type="text"
      aria-label={label}
      name={name}
      placeholder={placeholder}
      className={`form-control ${className || ''}`}
      defaultValue={defaultValue}
      data-lpignore="true"
      autoComplete="off"
      onChange={onChange}
      autoFocus={autoFocus ?? false}
      disabled={disabled ?? false}
      list={`datalist-${name}`}
    />
    <datalist id={`datalist-${name}`}>
      {items?.map((item, index) => (
        <option key={index}>{item}</option>
      ))}
    </datalist>
  </FormGroup>
);
export default FormDataList;
